<template>
  <el-dialog
    :visible.sync="visible"
    title="项目授权"
    width="950px"
    append-to-body
  >
    <el-row type="flex" justify="start" align="top">
      <el-col :span="12">
        <el-card
          header="组织"
          shadow="never"
          style="margin-top: 0;"
          :body-style="{ height: '400px', overflow: 'auto', padding: '10px' }"
        >
          <el-input
            v-model="filterText"
            placeholder="请输入关键字进行过滤"
            clearable
          />
          <el-tree
            ref="tree"
            style="margin-top: 10px"
            highlight-current
            node-key="orgOrganId"
            :data="organTreeData"
            :props="{ children: 'children', label: 'organName' }"
            :default-expanded-keys="defaultShowNodes"
            :filter-node-method="filterNode"
            @node-click="selectOrganCallback"
          >
            <template #default="{ node, data }">
              <span class="custom-tree-node">
                <el-tag
                  size="small"
                  :style="{
                    color: '#333',
                    background: '#EDEDED',
                    borderColor: '#EDEDED'
                  }"
                >
                  <!--                {{ ORGAN_TYPE[data.organType] }}-->
                  {{ data.organTypeName }}
                </el-tag>
                <span
                  class="dib"
                  style="font-size: 14px"
                >{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card
          v-loading="loading"
          header
          style="margin-top: 0;"
          shadow="never"
          :body-style="{ height: '400px', overflow: 'auto', padding: '10px' }"
        >
          <template #header>
            <div class="clearfix">
              <span>项目<i style="margin-left: 5px;color:#ccc; cursor: pointer" class="el-icon-warning-outline" /> <span style="font-weight: normal;color:#ccc">如果给父级授权，后续父级下再新增子级会自动授权</span></span>
            </div>
          </template>
          <el-row>
            <el-col :span="24">
              <el-input
                v-model="filterProject"
                placeholder="请输入关键字进行过滤"
                clearable
              />
            </el-col>
          </el-row>
          <el-tree
            ref="treeProject"
            style="margin-top: 10px"
            node-key="busProjectId"
            :data="projectTreeData"
            :props="defaultProps"
            :filter-node-method="filterProjectNode"
            :default-expanded-keys="defaultProject"
            check-on-click-node
            :check-strictly="true"
            :show-checkbox="true"
            @check-change="checkChange"
          >
            <template #default="{ node, data }">
              <span class="custom-tree-node">
                <el-tag
                  size="small"
                  :style="{
                    color: '#333',
                    background: '#EDEDED',
                    borderColor: '#EDEDED'
                  }"
                >
                  <!--                  {{ data.projectTypeName }}-->
                  {{ PROJECT_TYPE[data.projectTypeCode] }}
                </el-tag>
                <span
                  class="dib"
                  style="font-size: 14px"
                >{{ node.label }}</span>
              </span>
            </template>
          </el-tree>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" justify="start" align="top">
      <el-col :span="24">
        <el-card
          shadow="never"
          style="margin-top: 0;"
          :body-style="{ height: '100px', overflow: 'auto', padding: '10px' }"
        >
          <el-tag v-for=" (item, index) in checkedList " :key="index" style="margin-right: 5px;margin-bottom: 5px" closable @close="handleClose(item, index)">{{ item.projectName }}</el-tag>
        </el-card>
      </el-col>
    </el-row>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="visibleInner = false, checkedList = []">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  apiOrganPUserGetOrganAddModelTree,
  apiOrganPUserGetProjectAddModelTree
} from '@/api/manage'
import { ORGAN_TYPE, PROJECT_TYPE } from '@/enum'
export default {
  name: 'SelectProjectAuth',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orgUserUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchForm: {
        orgOrganId: ''
      },
      ORGAN_TYPE,
      PROJECT_TYPE,
      filterText: '',
      organTreeData: [],
      filterProject: '',
      projectTreeData: [],
      // searchParam: {
      //   orgOrganId: ''
      // },

      defaultProps: {
        children: 'children',
        label: 'projectName',
        disabled: (data, node) => {
          return data.readOnly
        }
      },
      loading: false,
      busOrganObj: {},
      checkedList: [],

      defaultShowNodes: [],
      defaultProject: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
        if (!val) {
          this.checkedList = []
        }
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    filterProject(val) {
      this.$refs.treeProject.filter(val)
    },
    value(val) {
      if (val) {
        this.checkedList = []
        this.selectOrganTree()
      }
    },
    organTreeData: {
      handler() {
        this.organTreeData.forEach((item) => {
          this.defaultShowNodes.push(item.orgOrganId)
        })
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    // this.selectOrganTree()
  },
  methods: {

    handleAfterLeave() {
      this.$destroy(true)
      // this.$el.parentNode.removeChild(this.$el) // 可能移除的时候组件已经不存在了
    },
    filterNode(value, data) {
      if (!value) return true
      return data.organFullName.indexOf(value) !== -1
    },
    filterProjectNode(value, data) {
      if (!value) return true
      return data.projectName.indexOf(value) !== -1
    },
    // 获取组织架构
    selectOrganTree() {
      apiOrganPUserGetOrganAddModelTree({ orgUserUuid: this.orgUserUuid }).then((d) => {
        //
        this.organTreeData = d.data
        if (d.data.length === 0) return false
        this.$nextTick(() => {
          this.$refs.tree.setCurrentNode(d.data[0])
          this.searchForm.orgOrganId = d.data[0].orgOrganId
          // this.$refs.tree.setCurrentKey(this.organTreeData[0].orgOrganId, true) // 默认选中第一个节点
        })
        this.selectOrganCallback(this.organTreeData[0])
      })
    },
    // 选中的组织架构节点
    selectOrganCallback(data, node, component) {
      // 切换左侧 回显右侧数据
      const ids = this.checkedList.map(i => i.busProjectId)
      this.$refs.treeProject.setCheckedKeys(ids)

      this.searchForm.orgOrganId = data.orgOrganId
      this.busOrganObj = data
      this.searchProject()
    },
    // 获取项目树数据
    searchProject() {
      this.loading = true
      apiOrganPUserGetProjectAddModelTree({ orgOrganId: this.searchForm.orgOrganId, orgUserUuid: this.orgUserUuid }).then((d) => {
        this.loading = false
        this.projectTreeData = d.data
        if (d.data.length === 0) return false
        this.projectTreeData.forEach((item) => {
          this.defaultProject.push(item.busProjectId)
        })
        this.$nextTick(() => {
          this.$refs.treeProject.setCurrentNode(d.data[0])
        })
      }).catch((e) => {
        this.loading = false
        this.$errorHandle(e)
      })
    },
    check(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      //
    },
    checkChange(data, checked, indeterminate) {
      // //
      // 父选中 子节点全部选中
      if (checked && data && data.children) {
        data.children.forEach(item => {
          this.$refs.treeProject.setChecked(item.busProjectId, true)
        })
      }
      if (!checked && data && data.children.length > 0) {
        const arr = this.$refs.treeProject.getCheckedKeys()
        //
        const tag = data.children.some(item => {
          return !(arr.includes(item.busProjectId))
          // this.$refs.treeProject.setChecked(item.busProjectId, false)
        })
        //
        if (!tag) {
          data.children.forEach(item => {
            this.$refs.treeProject.setChecked(item.busProjectId, false)
          })
        }
      }
      // // 子取消 父节点也取消
      if (!checked) {
        //
        this.$refs.treeProject.setChecked(data.projectParentId, false)
      }

      if (checked) {
        this.checkedList.push(data)
      } else {
        let idx = 0
        this.checkedList.forEach((i, index) => {
          if (i.busProjectId === data.busProjectId) {
            idx = index
          }
        })
        this.checkedList.splice(idx, 1)
      }
    },
    // findchildren(current) {
    //   this.$refs.treeProject.setChecked(current.busProjectId, true)
    //   const d = current.children
    //   if (d.length > 0) {
    //     d.forEach(a => {
    //       this.findchildren(a)
    //     })
    //   }
    // },
    handleClose(it, idx) {
      // 当前树选中的
      const ids = this.$refs.treeProject.getCheckedKeys()
      if (ids.indexOf(it.busProjectId) !== -1) {
        const id = it.busProjectId
        this.$refs.treeProject.setChecked(id, false, false)
      } else {
        this.checkedList.splice(idx, 1)
      }
    },
    submit() {
      const list = this.checkedList.map(i => i.busProjectId)
      // list = list.concat(this.$refs['treeProject'].getCheckedKeys())
      // //
      // list = list.concat(this.$refs['treeProject'].getHalfCheckedKeys())
      //
      if (list.length === 0) {
        this.$message.error('请选择项目')
      }
      this.$emit('submit', {
        orgOrganId: this.busOrganObj.orgOrganId,
        ids: list
      })
    }
  }
}
</script>

<style scoped>
</style>
